export default "__VITE_ASSET___z8zolrs__"